import { Organizacao } from './../shared/model/organizacao';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AtivacaoService } from '../shared/service/ativacao/ativacao.service';
import { SegurancaService } from '../shared/service/seguranca/seguranca.service';
import { Usuario } from '../shared/index';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../shared/service/login/login.service';
import { UsuarioService } from '../shared/service/usuario/usuario.service';
import { UtilService } from '../shared/service/util/util.service';

declare var $: any;

@Component({
  selector: 'app-ativacao',
  templateUrl: './ativacao.component.html',
  styleUrls: ['./ativacao.component.css']
})
export class AtivacaoComponent implements OnInit {

  public usuario = new Usuario();
  public regex: string;
  public descricaoRegex: string;
  public organizacao: Organizacao;
  public fluxoVarejo = false;

  public confirm: string;
  public confirmPin: string;
  public confirmEmail: string;

  public titulo: string;
  public descricao: string;
  public passo: number;

  public showSpinner: boolean = false;

  @ViewChild('f', { static: true }) form;

  constructor(
    private ativacaoService: AtivacaoService,
    private route: ActivatedRoute,
    private utilService: UtilService,
    private loginService: LoginService,
    private segurancaService: SegurancaService,
    private usuarioService : UsuarioService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.showSpinner = true;

    this.ativarPasso1();
    const token = this.route.snapshot.params.token;

    this.usuarioService.obterDadosUsuarioPorToken(token).subscribe(
      res => {
        this.usuario.pinTemporario = res.pinTemporario;
        this.usuario.token = this.route.snapshot.params.token;
        this.usuario.cpf = res.cpf;
        if (!this.usuario.pinTemporario) {
          this.usuario.email = res.email;
        }
        this.obterPoliticaSenhaPadrao();
        this.obterOrganizacao();
        this.showSpinner = false;
      },
      err => {
        this.showSpinner = false;
        this.loginService.logout();
        localStorage.setItem('errMessage', err.message);
      }
    );    
  }

  habilitarPasso1() {
    let habilitar : boolean;

    if (this.usuario.pinTemporario) {
      habilitar = (!this.usuario.nome || !this.usuario.email || !this.usuario.senha) || !this.form.valid;
    } else {
      habilitar = (!this.usuario.nome || !this.usuario.cpf || !this.usuario.senha) || !this.form.valid;
    }
    return habilitar;
  }

  habilitarPasso2() {
    return !this.usuario.pin || !this.form.valid;
  }

  ativarPasso1() {
    this.passo = 1;
    this.titulo = "Cadastro";
    this.descricao = "Preencha as informações para você ter acesso a plataforma RemoteID";
  }

  ativarPasso2() {
    if (this.usuario.pinTemporario) {
      this.passo = 2;
      this.titulo = "Cadastre seu PIN";
      this.descricao = "O PIN é a sua senha de utilização do seu Certificado";
    } else {
      this.mostrarTermo();     
    }
  }

  ativarPasso3() {
    this.passo = 3;
    this.titulo = "";
    this.descricao = "Parabéns!";
  }

  finalizar() {
    this.router.navigate(['/login']);
  }

  validarAtivacaoPasso1() {
    this.showSpinner = true;
      this.ativacaoService.validarAtivacaoPasso1(this.usuario).subscribe(
        () => {
          this.ativarPasso2();
          this.showSpinner = false;
        },
        err => {
          this.showSpinner = false;
          if (err.status === 401 || err.status === 403) {
            this.loginService.logout();
          }
          this.utilService.showError(err.message);
        }
      );
  }

  validarAtivacaoPasso2() {
    this.showSpinner = true;
    this.ativacaoService.validarAtivacaoPasso2(this.usuario).subscribe(
      () => {
        this.showSpinner = false;
        this.mostrarTermo();    
      },
      err => {
        this.showSpinner = false;
        if (err.status === 401 || err.status === 403) {
          this.loginService.logout();
        }
        this.utilService.showError(err.message);
      }
    );
  }

  ativar() {
    this.showSpinner = true;
    this.ativacaoService.ativar(this.usuario).subscribe(
      () => {
        this.showSpinner = false;
        this.ativarPasso3();        
      },
      err => {
        this.showSpinner = false;
        if (err.status === 401 || err.status === 403) {
          this.loginService.logout();
        }
        this.utilService.showError(err.message);
      }
    );
  }

  aceitarTermo() {
    this.usuario.termoAceitado = true;
    this.ativar();    
  }

  mostrarTermo() {
    this.usuario.termoAceitado = false;
    if (this.fluxoVarejo) {
      $('#termoDeUsoModal').modal('show');
    } else {
      this.ativar();
    }
  }

  mostrarRecusa() {
    $('#recusaModal').modal('show');
  }

  obterOrganizacao() {
    this.ativacaoService.obterOrganizacaoDeTokenAtivacaoV2(this.usuario.token).subscribe(
      res => {
        this.organizacao = res;
        this.organizacao.fluxoEmissaoVarejo = res.fluxoEmissaoVarejo;
      },
      err => {
        if (err.status === 401 || err.status === 403) {
          this.loginService.logout();
        }
        this.utilService.showError(err.message);
        this.organizacao = null;
        this.fluxoVarejo = false;
      }
    );
  }

  obterPoliticaSenhaPadrao() {
    this.segurancaService.obterPoliticaSenha().subscribe(
      res => {
        this.regex = res.regex;
        this.descricaoRegex = res.descricao;
      },
      err => {
        if (err.status === 401 || err.status === 403) {
          this.loginService.logout();
        }
        this.utilService.showError(err.message);
      }
    );
  } 
}